<template>
  <div v-if="logins">
    <login-base :error="error">
      <div
        v-for="login in logins"
        :key="login.connector">
        <password-less v-if="login.connector === 'email'"></password-less>
        <a
          v-else
          class="img-button"
          @click="doLogin(login.connector)">
          <svgicon :name="login.button" :original="true" width="185" height="40"></svgicon>
        </a>
      </div>
    </login-base>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LoginBase from '@/components/LoginBase.vue';
import PasswordLess from '../components/PasswordLess.vue';

export default {
  name: 'LoginAuth0',
  components: { LoginBase, PasswordLess },
  props: {
    loginsProp: {
      type: Array,
      default: null,
    },
  },
  computed: {
    ...mapState('auth', ['error']),
    ...mapGetters('auth', ['isLoggedIn']),
  },
  data() {
    return {
      logins: null,
    };
  },
  async mounted() {
    // The route does not call getOrRefreshToken because this is the login page
    // Call it and redirect to index if user is already logged in
    await this.$store.dispatch('auth/getOrRefreshToken');
    if (this.isLoggedIn) {
      this.$router.push({ name: 'index' });
    }

    if (this.loginsProp) {
      this.logins = this.loginsProp;
    } else {
      await this.getLoginsConfig();
    }
  },
  methods: {
    async getLoginsConfig() {
      const response = await this.axios.get('/config/login.json');
      if (Object.prototype.hasOwnProperty.call(response.data, 'logins')) {
        this.logins = response.data.logins;
      } else {
        this.logins = [
          {
            connector: 'google-oauth2',
            button: 'google_button',
          },
        ];
      }
    },
    async doLogin(connection) {
      this.$auth.authorize({
        connection,
      });
    },
    async doUserNamePasswordLogin() {
      // this.$auth.login({
      //   username: this.username,
      //   password: this.password,
      //   realm: 'Username-Password-Authentication',
      // });

      // this.$auth.authorize({
      //   connection: 'Username-Password-Authentication',
      // });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
